import { useFormik } from 'formik';
import { Flex, Stack } from "@chakra-ui/react";
import CustomInput from "../../form-components/CustomInput";
import SubmitButton from "../../custom/SubmitButton";
import { UseApi } from '../../../libraries/UseApi';
import { UserInfoContext } from '../../../provider/UserInfoProvider';
import * as Yup from 'yup';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import CustomSelect from '../../form-components/CustomSelect';
import { GetExpertLevelOptions, GetStackOptions, getTechnologyOptions } from '../../options/SelectOptions';

const AddSelfTechnologyForm = ({ technology = {}, isEdit = false, technologyData = [], stackData = [] }) => {
    const { postApi, patchApi } = UseApi();
    const { token } = useContext(UserInfoContext);
    const navigate = useNavigate();
    const formik = useFormik({
        initialValues: {
            technology: technology?.technology,
            stack: technology?.stack,
            expert_level: technology?.expert_level,
            experience: technology?.experience,
        },
        validationSchema: Yup.object({
            technology: Yup.string().required('技術は必修'),
            stack: Yup.string().required('技術分類は必修'),
            expert_level: Yup.number().required('レベルは必修'),
            experience: Yup.string().required('経験は必修'),
        }),
        onSubmit: (values) => {
            if (isEdit) {
                patchApi(
                    `${process.env.REACT_APP_API_URL}/technology/${technology?.id}`, values, { token: token },
                    (response) => {
                        // レスポンスチェック
                        if (response.isSuccess === false) {
                            // 入力内容を確認してください。
                            //alert(Message.Common.CONFIRM_INPUT);
                            return;
                        }
                        navigate('/my-technologies');
                    }
                );
            } else {
                postApi(
                    `${process.env.REACT_APP_API_URL}/me/technology/add`, values, { token: token },
                    (response) => {
                        // レスポンスチェック
                        if (response.isSuccess === false) {
                            // 入力内容を確認してください。
                            //alert(Message.Common.CONFIRM_INPUT);
                            return;
                        }
                        navigate('/my-technologies');
                    }
                );
            }
        }
    });

    return (
        <form onSubmit={formik.handleSubmit}>
            <Stack spacing={4} key={'addTechnology'}>
                <CustomSelect
                    formik={formik}
                    label={'技術種類'}
                    name={'stack'}
                    id={'stack'}
                    options={GetStackOptions(stackData)}
                    required={true}
                />
                <CustomSelect
                    formik={formik}
                    label={'技術'}
                    name={'technology'}
                    id={'technology'}
                    options={getTechnologyOptions(technologyData?.technologies || [], formik.values.stack)}
                    required={true}
                />
                <CustomSelect
                    formik={formik}
                    label={'レベル'}
                    name={'expert_level'}
                    id={'expert_level'}
                    options={GetExpertLevelOptions()}
                    required={true}
                />
                <CustomInput
                    formik={formik}
                    label={'経験技術'}
                    type={'text'}
                    name={'experience'}
                    id={'experience'}
                    placeholder={'経験技術を入力(i.e. 2年)'}
                    required={true}
                />
                <Stack spacing={10}>
                    <Flex gap={2}>
                        <SubmitButton buttonText={isEdit ? '編集' : '登録'} />
                    </Flex>
                </Stack>
            </Stack>
        </form>
    );
}

export default AddSelfTechnologyForm;